import { render, staticRenderFns } from "./FormWizardNumber.vue?vue&type=template&id=24986098&scoped=true&"
import script from "./FormWizardNumber.vue?vue&type=script&lang=js&"
export * from "./FormWizardNumber.vue?vue&type=script&lang=js&"
import style0 from "./FormWizardNumber.vue?vue&type=style&index=0&id=24986098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24986098",
  null
  
)

export default component.exports